export const LIST_PATH = '/'
export const ACCOUNT_PATH = '/account'
export const LOGIN_PATH = '/login'
export const SIGNUP_PATH = '/signup'
export const GAME_PATH = '/game'
export const GAMES_PATH = '/games'
export const ABOUT_PATH = '/over-manillen-online'
export const LEADERBOARD_PATH = '/leaderboard'
